'use strict';

let latlng_url 		 = js_translations['outlet_locator_url'],
    iw_url     		 = js_translations['outlet_landing_page'],
    locations  		 = js_translations['outlet_locations'],
    modal_btn_title  = js_translations['outlet_modal_btn_title'],
    marker_img       = "/static/themes/goossens/img/icons/google/marker.svg",
    marker_cluster_img  = "/static/themes/goossens/img/icons/google/marker_empty.png",
    markers    		 = [],
    cluster_styles   = [{textColor: 'white', textSize:'14', fontFamily: 'Montserrat', url:marker_cluster_img, width:31, height:50, backgroundRepeat: 'no-repeat', backgroundSize: 'contain', lineHeight: 32}],
    cluster_options  = {gridSize:30, styles:cluster_styles, maxZoom:12},
    map				 = {},
    marker_active 	 = {},
    marker_inactive  = {},
    standard_lat 	 = JSON.parse($('#js-standard-coordinates').html()).coordinates.lat,
    standard_lon 	 = JSON.parse($('#js-standard-coordinates').html()).coordinates.lon,
    savedTerm        = '',
    userLat,
    userLon,
    userLocationUsed = false,
    storeList = $(".locator__left .store_list"),
    term = $('#geo-search').val();

function initOutletMap() {
    var map_canvas  = document.getElementById('map_canvas'),
        bounds      = new google.maps.LatLngBounds(),
        map_options = {zoom:7, mapTypeId:google.maps.MapTypeId.ROADMAP, center:new google.maps.LatLng(standard_lat, standard_lon), mapTypeControl:false};

    map = new google.maps.Map(map_canvas, map_options);
    marker_active = {
        url: marker_img,
        scaledSize: new google.maps.Size(32, 50)
    }, marker_inactive = {
        url: marker_img,
        scaledSize: new google.maps.Size(32, 50)
    }
}

function currentPosition() {
    if(!navigator.geolocation) {
        map.panTo(new google.maps.LatLng(standard_lat, standard_lon))
    } else {
        navigator.geolocation.getCurrentPosition(currentPositionSuccess, currentPositionError)
    }
}

function currentPositionSuccess(position) {
    if(userLocationUsed == false) {

        userLat = position.coords.latitude,
        userLon = position.coords.longitude;

        $('#geo-search').val('');

        term = savedTerm = '';
        userLocationUsed = true;

        $('.locator__left .store').each(function() {
            const storeLat       = $(this).attr('data-lat'),
                  storeLon       = $(this).attr('data-lon'),
                  ding           = distance(userLat, userLon, storeLat, storeLon, 'K'),
                  roundedString  = ding.toFixed(2),
                  rounded        = Number(roundedString);

            $(this).data('distance', rounded);
            $(this).find('.store_openingstijden').html(`${rounded} KM van u vandaan`);
        })

        $(storeList).each(function () {
            $(this).html($(this).children('.store').sort(function (a, b) {
                return ($(b).data('distance')) < ($(a).data('distance')) ? 1 : -1;
            }));
        });

        map.setZoom(12);
        map.panTo(new google.maps.LatLng(userLat, userLon));

        $(storeList).removeClass('hidden');
    }
}

function currentPositionError(e) {
    console.error(e);
}

function initMarkers() {
    let userlocation = false,
        searchterm   = js_translations['outlet_searchterm'],
        usrlat 		 = '',
        usrlon 		 = '';

    for (let i=0; i<js_translations['outlet_locations'].length; i++){
        initMarker(js_translations['outlet_locations'][i]);
    }

    if (searchterm) {
        let center = new google.maps.LatLng(usrlat, usrlon);

        js_translations['outlet_locations'].forEach((o, index) => {
            var latLng = new google.maps.LatLng(o.address.geo_latitude, o.address.geo_longitude);
            bounds.extend(latLng);
            (index == js_translations['outlet_locations'].length ? map.fitBounds(bounds): '') ;
        });
        map.panTo(center);

    } else if (userlocation) {
        let center = new google.maps.LatLng(usrlat, usrlon);
        map.panTo(center);
    }

    let marker_clusterer = new MarkerClusterer(map, markers, cluster_options);
}

function initMarker(location) {
    let buttonName = js_translations?.['outlet_button_name'] ?? 'View store';
    const infoWindowContent = `
    <div class="store">
    <div class="inner" style="display: flex;flex-direction: column;align-items: center;">
    <h3 class="playfair"><a href="${location.url}" target=_blank>${location.name}</a></h3>
    <small>${location.address.street1}</small>
    <a href="${location.url}" target=_blank class="btn__custom btn__custom--stores" style="margin-top: 1rem;">${buttonName}</a>
    </div>
    </div>
    `;

    let infowindow = new google.maps.InfoWindow({content: infoWindowContent});
    var latLng = new google.maps.LatLng(location.address.geo_latitude, location.address.geo_longitude),
    marker = new google.maps.Marker({map:map, position:latLng, title:location.name, infowindow:infowindow, icon:marker_inactive}),
    i;

    marker.id = location.id;

    marker.addListener('click', function(){
        setMarkerIcon(marker);
        panToMarker(map, marker);
        hideAllInfoWindows(map);
        this.infowindow.open(map, this);
    });

    markers.push(marker);
}

function hideAllInfoWindows(map) {
    markers.forEach(function(marker) {
        marker.infowindow.close(map, marker);
    });
}

function setMarkerIcon(marker) {
    for (let j = 0; j < markers.length; j++) {
        markers[j].setIcon(marker_inactive);
    }

    marker.setIcon(marker_active);
}

function panToMarker(map, marker) {
    map.setZoom(16);
    map.panTo(marker.getPosition());
}

function getSearchLocation() {
    $('#js-mapsearch').on('submit', function(e) {
        term = $('#geo-search').val();
        e.preventDefault();

        if (term !== '' && term != savedTerm) {

            savedTerm        = term;
            userLocationUsed = false;

            const geocoder =  new google.maps.Geocoder();

            geocoder.geocode({'address': term}, function(results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    const storeList = $(".locator__left .store_list");

                    $('#geo-search').removeClass('has-error');
                    $('.form-validation-error').remove();

                    let searchLat = null,
                    searchLon = null;

                    $('.locator__left .store').each(function() {
                        searchLat     = results[0].geometry.location.lat();
                        searchLon     = results[0].geometry.location.lng();

                        const storeLat      = $(this).data('lat'),
                        storeLon      = $(this).data('lon'),
                        ding          = distance(searchLat, searchLon, storeLat, storeLon, 'K'),
                        roundedString = ding.toFixed(2),
                        rounded       = Number(roundedString);

                        $(this).data('distance', rounded);
                        $(this).find('.store_openingstijden').html(`${rounded} KM vanaf '${$('#geo-search').val()}'`);
                    });

                    $(storeList).each(function () {
                        $(this).html($(this).children('.store').sort(function (a, b) {
                            return ($(b).data('distance')) < ($(a).data('distance')) ? 1 : -1;
                        }));
                    });

                    map.panTo(new google.maps.LatLng(searchLat, searchLon));
                    map.setZoom(12);

                    $(storeList).removeClass('hidden');

                } else if (status == google.maps.GeocoderStatus.ZERO_RESULTS) {
                    $('#geo-search').addClass('has-error');
                    $('.form-validation-error').remove();
                    $('#geo-search').parent('.form-group').after(`<div class="form-validation-error">${$('#js-no-results-text').val()}</div>`);
                }
                else {
                }
            });
        }
    });
}

function searchLocationUserLocation() {
    $('#js-use-userlocation').on('click', function(e) {
        currentPosition();
    })
}

function defer2(method) {
    if (window.jQuery && window.google) {
        if (method instanceof Array) {
            for (var i=0; i<method.length; i++) {
                method[i]();
            }
        } else {
            method();
        }
    } else {
        setTimeout(function() { defer2(method) }, 50);
    }
}

function defer(method) {
    if (window.jQuery) {
        if (method instanceof Array) {
            for (var i=0; i<method.length; i++) {
                method[i]();
            }
        } else {
            method();
        }
    } else {
        setTimeout(function() { defer(method) }, 50);
    }
}

function debounce (func, wait, immediate) {
    var timeout;

    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

function distance(lat1, lon1, lat2, lon2, unit) {
    let radialLat1  = Math.PI * lat1 / 180,
    radialLat2  = Math.PI * lat2 / 180,
    theta       = lon1 - lon2,
    radialTheta = Math.PI * theta / 180,
    distance    = Math.sin(radialLat1) * Math.sin(radialLat2) + Math.cos(radialLat1) * Math.cos(radialLat2) * Math.cos(radialTheta);

    if (distance > 1) {
        distance = 1;
    }

    distance = Math.acos(distance) * 180 / Math.PI * 60 * 1.1515;

    if (unit == "K") { distance = distance * 1.609344 };
    if (unit == "N") { distance = distance * 0.8684 };

    return distance;
};

function getUserLocation () {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(setUserPosition);
    }
};

function setUserPosition(position) {
    userLat = position.coords.latitude;
    userLon = position.coords.longitude;
};

window.defer = defer;
window.setUserPosition = setUserPosition;
window.distance = distance;
window.debounce = debounce;
window.searchLocationUserLocation = searchLocationUserLocation;
window.getSearchLocation = getSearchLocation;
window.panToMarker = panToMarker;
window.setMarkerIcon = setMarkerIcon;
window.hideAllInfoWindows = hideAllInfoWindows;
window.initMarker = initMarker;
window.currentPositionError = currentPositionError;
window.currentPositionSuccess = currentPositionSuccess;
window.currentPosition = currentPosition;
window.initOutletMap = initOutletMap;

defer([getSearchLocation, searchLocationUserLocation])
defer2([initOutletMap, initMarkers])